// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { Warning } from '../'


const InboundMessage = React.forwardRef(({ type, fromIdentityName, createdAt, body, selected, isSMS, onClick, className, style }, ref ) => {
  let styleWithPointer = { ...style, ...{ cursor: 'pointer' } }

  if (type === 'TEXT' || isSMS) {
    let textMessage = body
    return (
      <li
        className={`chat-listitem chat-listitem_inbound${selected ? ' item-selected' : ''} ${className}`}
        onClick={onClick}
        style={styleWithPointer}
        ref={ref}>
        <div className='chat-message'>
          <div className='chat-message__body'>
            <div className='chat-message__text chat-message__text_inbound' style={{ backgroundColor: '#b9e0b9' }}>
              <span>{textMessage}</span>
            </div>
            <div className='chat-message__meta slds-text-align_left'>
              {`${fromIdentityName} • ${moment(createdAt).format('DD MMM YYYY HH:mm:ss')}`}
            </div>
          </div>
        </div>
      </li>
    )
  } else if (type === 'VOICE') {
    return (
      <li
        className={`chat-listitem chat-listitem_inbound${selected ? ' item-selected' : ''} ${className}`}
        onClick={onClick}
        style={styleWithPointer}
        ref={ref}>
        <div className='chat-message'>
          <div className='chat-message__body'>
            <div className='chat-message__text chat-message__text_inbound' style={{ backgroundColor: '#b9e0b9' }}>
              <span>
                <span className='slds-icon_container slds-icon-doctype-attachment chat-icon' title='Voice note'>
                  <svg className='slds-icon slds-icon_small' aria-hidden='true'>
                    <use xlinkHref='/assets/icons/doctype-sprite/svg/symbols.svg#audio'></use>
                  </svg>
                  <span className='slds-assistive-text'>Voice note</span>
                </span>
                Voice note
              </span>
            </div>
            <div className='chat-message__meta slds-text-align_left'>
              {`${fromIdentityName} • ${moment(createdAt).format('DD MMM YYYY HH:mm:ss')}`}
            </div>
          </div>
        </div>
      </li>
    )
  } else if (['FILE', 'DOCUMENT', 'IMAGE'].indexOf(type) > -1) {
    return (
      <li
        className={`chat-listitem chat-listitem_inbound${selected ? ' item-selected' : ''} ${className}`}
        onClick={onClick}
        style={styleWithPointer}
        ref={ref}>
        <div className='chat-message'>
          <div className='chat-message__body'>
            <div className='chat-message__text chat-message__text_inbound' style={{ backgroundColor: '#b9e0b9' }}>
              <span>
                <span className='slds-icon_container slds-icon-doctype-attachment chat-icon' title='Attachment'>
                  <svg className='slds-icon slds-icon_small' aria-hidden='true'>
                    <use xlinkHref='/assets/icons/doctype-sprite/svg/symbols.svg#attachment'></use>
                  </svg>
                  <span className='slds-assistive-text'>Attachment</span>
                </span>
                {/* eslint-disable jsx-a11y/href-no-hash */}
                <a href='#'>filename_of_attachment.jpg</a>
                {/* eslint-enable jsx-a11y/href-no-hash */}
              </span>
            </div>
            <div className='chat-message__meta slds-text-align_left'>
              {`${fromIdentityName} • ${moment(createdAt).format('DD MMM YYYY HH:mm:ss')}`}
            </div>
          </div>
        </div>
      </li>
    )
  } else {
    return (
      <li
        className={`chat-listitem chat-listitem_inbound${selected ? ' item-selected' : ''} ${className}`}
        onClick={onClick}
        style={styleWithPointer}
        ref={ref}>
        <div className='chat-message'>
          <div className='chat-message__body'>
            <div className='chat-message__text chat-message__text_inbound' style={{ backgroundColor: '#b9e0b9' }}>
              <Warning>Unknown message type</Warning>
            </div>
            <div className='chat-message__meta slds-text-align_left'>
              {`${fromIdentityName} • ${moment(createdAt).format('DD MMM YYYY HH:mm:ss')}`}
            </div>
          </div>
        </div>
      </li>
    )
  }
})

InboundMessage.propTypes = {
  type: PropTypes.oneOf(['TEXT', 'FILE', 'AUDIO', 'DOCUMENT', 'IMAGE', 'HSM']).isRequired,
  fromIdentityName: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  body: PropTypes.string,
  className: PropTypes.string
}

InboundMessage.defaultProps = {
  className: ''
}

export default InboundMessage



// WEBPACK FOOTER //
// ./src/components/employer-related-messages-list/InboundMessage.js